import React from 'react';
import { filterPractitioners } from '../helpers';
import { listboxRef, scrollContainerRef } from '../components/FilterDropdown';

const buildInitialFilters = (filtersConfig) =>
  (filtersConfig || []).reduce((acc, { key }) => ({ ...acc, [key]: [] }), {});

export const useTeamFilters = (people, filtersConfig = []) => {
  const [newFilters, setNewFilters] = React.useState(() =>
    buildInitialFilters(filtersConfig)
  );

  React.useEffect(() => {
    const config = filtersConfig || [];
    setNewFilters((prev) => {
      const next = config.reduce(
        (acc, { key }) => ({ ...acc, [key]: prev[key] ?? [] }),
        {}
      );
      const prevKeys = Object.keys(prev).sort().join();
      const nextKeys = Object.keys(next).sort().join();
      return prevKeys !== nextKeys ? next : prev;
    });
  }, [filtersConfig]);

  const [filterSearchTerms, setFilterSearchTerms] = React.useState({});
  const [openFilterKey, setOpenFilterKey] = React.useState(null);
  const scrollPositionToRestore = React.useRef(null);

  const handleNewFilter = (key) => (e) => {
    const scrollEl = scrollContainerRef.current || listboxRef.current;

    if (scrollEl) {
      scrollPositionToRestore.current = scrollEl.scrollTop;
    }

    const value = e.target.value;

    setNewFilters((prev) => ({
      ...prev,
      [key]: typeof value === 'string' ? (value ? [value] : []) : value,
    }));
  };

  const filtered = React.useMemo(
    () => filterPractitioners(people, newFilters),
    [people, newFilters]
  );

  return {
    newFilters,
    setNewFilters,
    filterSearchTerms,
    setFilterSearchTerms,
    openFilterKey,
    setOpenFilterKey,
    handleNewFilter,
    filtered,
    scrollPositionToRestore,
  };
};
